export default range => Math.random() * range;
